import { TrackingAnalytics } from './TrackingAnalytics';

const CreatorRibbon = (name) => {
  return `CrRibb-${name}`;
};

export const CreatorRibbonAnalytics = {
  creatorRibbTab(tabName) {
    const name = CreatorRibbon(tabName);
    TrackingAnalytics.send(name, { source: 'react' });
  },
};
